import { useEffect } from 'react';

export function useHardwareOptimization() {
  useEffect(() => {
    // 1. Memory and CPU Degradation
    const checkHardware = () => {
      const memory = navigator.deviceMemory || 4; // Default to 4GB if unsupported
      const cores = navigator.hardwareConcurrency || 4;
      
      // If the device has less than 2GB of RAM or less than 4 CPU cores, enable lite mode
      if (memory < 2 || cores < 4) {
        document.documentElement.classList.add('lite-mode');
      }
    };

    // 2. Network-Aware Adjustments
    const checkNetwork = () => {
      if (navigator.connection) {
        const type = navigator.connection.effectiveType;
        // e.g. 'slow-2g', '2g', '3g', '4g'
        if (type === 'slow-2g' || type === '2g' || type === '3g') {
          document.documentElement.classList.add('slow-network');
        } else {
          document.documentElement.classList.remove('slow-network');
        }
      }
    };

    checkHardware();
    checkNetwork();

    // Listen for network changes dynamically
    if (navigator.connection) {
      navigator.connection.addEventListener('change', checkNetwork);
      return () => {
        navigator.connection.removeEventListener('change', checkNetwork);
      };
    }
  }, []);
}
